<template>
  <div class="wrapper">
    <div class="card">
      <div class="card-header-title">
        <span class="asset-title">{{ saleItem.assetName }}</span>
        <div class="actions">
          <a class="button is-dark is-outlined" :href="urlToExplorer(saleItem)" target="_blank">
           <span class="icon">
              <i class="fas fa-eye"></i>
            </span>
          </a>
          <span class="tag is-medium has-background-blue has-text-white" v-if="isNormalAsset">
            {{ saleItem.amount }} assets
          </span>
          <span class="tag is-medium has-background-danger has-text-white">
            {{ saleItem.price }} EVR
          </span>
        </div>
      </div>
      <div class="card-content">
        <div class="content">
          {{ description }}
        </div>
        <div class="tags are-medium" v-if="saleItem.tags && saleItem.tags.length > 0">
          <span class="tag is-link" v-for="tag in saleItem.tags" @click="tagSearch(tag)">
            {{ tag }}
          </span>
        </div>
      </div>
      <footer class="card-footer" v-if="isLoggedIn">
        <a class="card-footer-item" v-if="isOwned" @click="cancelInit">Cancel</a>
        <a class="card-footer-item" v-else-if="hasAccessToTrade" @click="purchaseInit">Purchase</a>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'sale-item',
  props: ['saleItem'],
  computed: {
    hasAccessToTrade() {
      return this.$store.getters.userCanTrade;
    },
    isNormalAsset() {
      return !this.saleItem.assetName.endsWith('!');
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    description() {
      return (this.saleItem.description != null) ? this.saleItem.description : 'No description';
    },
    isOwned() {
      return this.isLoggedIn && this.$store.getters.user.id === this.saleItem.sellerId;
    },
  },
  methods: {
    urlToExplorer(item) {
      const trimmedName = item.assetName.endsWith('!')
        ? item.assetName.slice(0, -1)
        : item.assetName;
      const assetName = trimmedName
        .replace(/\//g, '%2F')
        .replace(/#/g, '%23');
      return `https://assetexplorer.evrland.net/asset/${assetName}`;
    },
    purchaseInit() {
      this.$emit('purchase');
    },
    cancelInit() {
      this.$emit('cancel');
    },
    tagSearch(tag) {
      this.$emit('tagsearch', tag);
    },
  },
};

</script>

<style scoped>

.card {
  min-width: 300px;
  /*min-height: 400px;*/
}

.wrapper {
  padding: 0px 10px;
}

.asset-title {
  margin-right: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.content {
  margin-bottom: 25px;
  max-width: 400px;
  overflow: hidden;
  text-overflow-ellipsis: none;
}

.card-header-title {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.button {
  margin-right: 8px;
  max-height: 32px;
}

.has-background-blue {
  background-color: hsl(217, 71%, 53%);
}

@media screen and (max-width: 400px) {

  .wrapper {
    width: 100%;

  }

  .card {
    width: 100%;
  }
}

.card-content {
  max-width: 100%;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-header-title {
  display: flex;
  justify-content: space-between;
}

.asset-title {
  font-size: 1.5em;
}

.wrapper {
  margin-bottom: 20px;
}

.tag:hover {
  cursor: pointer;
}

</style>
